var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordClosedEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.25L19.5 20.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5226 15.2748C13.7866 15.9437 12.8151 16.2929 11.8217 16.2456C10.8284 16.1982 9.89446 15.7582 9.22548 15.0223C8.5565 14.2865 8.20723 13.315 8.25448 12.3216C8.30174 11.3282 8.74167 10.3943 9.47749 9.72522",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93698 6.93066C3.11486 8.86618 1.5 12.5 1.5 12.5C1.5 12.5 4.5 19.2493 12 19.2493C13.7572 19.2633 15.4926 18.8585 17.0623 18.0685",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5571 16.3531C21.6011 14.5224 22.5 12.5 22.5 12.5C22.5 12.5 19.5 5.74928 12 5.74928C11.3504 5.74822 10.7019 5.80103 10.061 5.90717",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7057 8.81635C13.5027 8.96939 14.2287 9.37674 14.7746 9.97728C15.3205 10.5778 15.657 11.3392 15.7336 12.1472",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordClosedEyeIcon);
export default __webpack_public_path__ + "static/media/passwordClosedEyeIcon.b3ff0e9d6edb3ccb1ce2f942d84681d5.svg";
export { ForwardRef as ReactComponent };